import Router from 'vue-router'

/**
 * 静态路由
 */
export const constantRouterMap = [
  {
    path: '/',
    name: 'Main',
    component: () => import('@/views/Main'),
    children: [
      {
        path: '/homepage',
        name: 'homepage',
        component: () => import('@/views/homepage/Homepage.vue'),
      },
      {
        path: '/HomepageUsso',
        name: 'HomepageUsso',
        component: () => import('@/views/homepage/HomepageUsso.vue'),
      },
      {
        path: '/message',
        name: 'message',
        component: () => import('@/views/message/MessageCenter.vue'),
      },
      {
        path: '/personal',
        name: 'personal',
        component: () => import('@/views/personal/PersonalCenter.vue'),
      },
      {
        path: '/ent/ent_info',
        name: 'ent_info',
        component: () => import('@/views/ent/EntInfo.vue')
      },
      {
        path: '/ent/bayonet',
        name: 'ent_bayonet',
        component: () => import('@/views/ent/bayonet.vue')
      },
      {
        path: '/ent/ent_info',
        name: 'ent_info',
        component: () => import('@/views/ent/EntInfo.vue')
      },
      {
        path: '/ent/factory_area',
        name: 'ent_factory_area',
        component: () => import('@/views/ent/EntFactoryArea.vue')
      },
      {
        path: '/ent/electric_fence',
        name: 'ent_electric_fence',
        component: () => import('@/views/ent/EntElectricFence.vue')
      },
      {
        path: '/ent/person_archive',
        name: 'ent_person_archive',
        component: () => import('@/views/ent/EntPersonArchive.vue')
      },
      {
        path: '/ent/work_post',
        name: 'ent_work_post',
        component: () => import('@/views/ent/EntWorkPost.vue')
      },
      {
        path: '/ent/certificate',
        name: 'ent_certificate',
        component: () => import('@/views/ent/EntCertificate.vue')
      },
      //危险源信息
      {
        path: '/ent/major_hazard_source',
        name: 'zd_hazard_source',
        component: () => import('@/views/hazardsource/HazardSource.vue')
      },
      {
        path: '/ent/hazardous_process',
        name: 'zd_hazardous_process',
        component: () => import('@/views/hazardsource/HazardousProcess.vue')
      },
      {
        path: '/ent/chemical',
        name: 'zd_chemical',
        component: () => import('@/views/hazardsource/Chemical.vue')
      },
      {
        path: '/ent/production_device',
        name: 'zd_production_device',
        component: () => import('@/views/hazardsource/ProductionDevice.vue')
      },
      {
        path: '/ent/leak_point',
        name: 'zd_leak_point',
        component: () => import('@/views/hazardsource/LeakPoint.vue')
      },
      {
        path: '/ent/storage_tank',
        name: 'zd_storage_tank',
        component: () => import('@/views/hazardsource/StorageTank.vue')
      },
      {
        path: '/ent/warehouse',
        name: 'zd_warehouse',
        component: () => import('@/views/hazardsource/Warehouse.vue')
      },
      //指标监测
      {
        path: '/monitor/indicator',
        name: 'monitor_indicator',
        component: () => import('@/views/monitor/realtime/MonitorIndicator.vue')
      },
      {
        path: '/monitor/real-time/data',
        name: 'monitor_data',
        component: () => import('@/views/monitor/realtime/MonitorData.vue')
      },
      {
        path: '/monitor/alarm',
        name: 'monitor_alarm',
        component: () => import('@/views/monitor/realtime/MonitorAlarm.vue')
      },
      {
        path: '/monitor/video',
        name: 'video_monitor',
        component: () => import('@/views/monitor/video/VideoMonitor.vue')
      },
      {
        path: '/monitor/bodyCamera',
        name: 'body_camera',
        component: () => import('@/views/monitor/video/BodyCamera.vue')
      },
      {
        path: '/monitor/video/alarm',
        name: 'video_alarm',
        component: () => import('@/views/monitor/video/VideoAlarm.vue')
      },
      {
        path: '/monitor/alarm/statistics',
        name: 'alarm_statistics',
        component: () => import('@/views/monitor/alarm/AlarmStatistics.vue')
      },
      {
        path: '/monitor/alarm/setting',
        name: 'alarm_setting',
        component: () => import('@/views/monitor/alarm/AlarmSetting.vue')
      },
      {
        path: '/monitor/equipment/monitor',
        name: 'equ_monitor',
        component: () => import('@/views/monitor/iot/EquMonitor.vue')
      },
      {
        path: '/monitor/equipment/sensor',
        name: 'equ_sensor',
        component: () => import('@/views/monitor/iot/EquSensor.vue')
      },
      {
        path: '/monitor/equipment/camera',
        name: 'equ_camera',
        component: () => import('@/views/monitor/iot/EquCamera.vue')
      },
      //危化品出入库
      {
        path: '/monitor/chemical/stock',
        name: 'chemical_stock',
        component: () => import('@/views/chemiaccess/ChemicalStock.vue')
      },
      {
        path: '/monitor/chemical/access_record',
        name: 'chemical_access_record',
        component: () => import('@/views/chemiaccess/ChemicalAccessRecord.vue')
      },
      //隐患整改
      {
        path: '/prevention/hid_danger/check_lib',
        name: 'hid_danger_check_lib',
        component: () => import('@/views/prevention/hiddanger/HidDangerCheckLib.vue')
      },
      {
        path: '/prevention/hid_danger/upload_fix',
        name: 'hid_danger_upload_fix',
        component: () => import('@/views/prevention/hiddanger/HidDangerUploadFix.vue')
      },
      //统计分析
      {
        path: '/prevention/hid_danger/statistic',
        name: 'hid_danger_statistic',
        component: () => import('@/views/prevention/hiddanger/HidDangerStatistic.vue')
      },
      {
        path: '/prevention/hid_danger/statistic_fix',
        name: 'hid_danger_statistic_fix',
        component: () => import('@/views/prevention/hiddanger/HidDangerStatisticFix.vue')
      },
      {
        path: '/prevention/hid_danger/fix_query',
        name: 'fix_query',
        component: () => import('@/views/prevention/hiddanger/FixQuery.vue')
      },
      {
        path: '/prevention/hid_danger/checklist',
        name: 'hid_danger_checklist',
        component: () => import('@/views/prevention/hiddanger/HidDangerCheckList.vue')
      },
      {
        path: '/prevention/hid_danger/plan',
        name: 'hid_danger_plan',
        component: () => import('@/views/prevention/hiddanger/HidDangerPlan.vue')
      },
      {
        path: '/prevention/hid_danger/holiday',
        name: 'hid_danger_holiday',
        component: () => import('@/views/prevention/hiddanger/HidDangerHoliday.vue')
      },
      {
        path: '/prevention/hid_danger/vacation',
        name: 'hid_danger_vacation',
        component: () => import('@/views/prevention/hiddanger/HidDangerVacation.vue')
      },
      {
        path: '/prevention/hid_danger/check',
        name: 'hid_danger_check',
        component: () => import('@/views/prevention/hiddanger/HidDangerCheck.vue')
      },
      {
        path: '/prevention/hid_danger/fix',
        name: 'hid_danger_fix',
        component: () => import('@/views/prevention/hiddanger/HidDangerFix.vue')
      },
      {
        path: '/prevention/hid_danger/duty_check_state',
        name: 'duty_deputy_activity_check_state',
        component: () => import('@/views/prevention/hiddanger/DutyCheckState.vue')
      },
      //安全检查
      {
        path: '/prevention/safe_check/tab',
        name: 'safe_check_tab',
        component: () => import('@/views/prevention/safecheck/SafeCheckTab.vue')
      },
      {
        path: '/prevention/safe_check/plan',
        name: 'safe_check_plan',
        component: () => import('@/views/prevention/safecheck/SafeCheckPlan.vue')
      },
      {
        path: '/prevention/safe_check/task',
        name: 'safe_check_task',
        component: () => import('@/views/prevention/safecheck/SafeCheckTask.vue')
      },
      //专项检查
      {
        path: '/prevention/special_check/task',
        name: 'hid_special_check_task',
        component: () => import('@/views/prevention/specialcheck/BaseCheckTask.vue')
      },
      {
        path: '/prevention/special_check/record',
        name: 'hid_special_check_record',
        component: () => import('@/views/prevention/specialcheck/BaseCheckRecord.vue')
      },
      //风险辨识
      {
        path: '/prevention/risk_area',
        name: 'risk_area',
        component: () => import('@/views/prevention/risk/RiskArea.vue')
      },
      {
        path: '/prevention/risk_chart',
        name: 'risk_chart',
        component: () => import('@/views/prevention/risk/RiskChart.vue')
      },
      {
        path: '/prevention/risk_identify',
        name: 'risk_identify',
        component: () => import('@/views/prevention/risk/RiskIdentify.vue')
      },
      {
        path: '/prevention/risk_control',
        name: 'risk_control',
        component: () => import('@/views/prevention/risk/RiskControl.vue')
      },
      {
        path: '/prevention/three_card/emergency_response',
        name: 'emergency_response',
        component: () => import('@/views/prevention/threecard/EmergencyResponse.vue')
      },
      {
        path: '/prevention/three_card/security_pledge',
        name: 'security_pledge',
        component: () => import('@/views/prevention/threecard/SecurityPledge.vue')
      },
      {
        path: '/prevention/three_card/risk_know',
        name: 'risk_know',
        component: () => import('@/views/prevention/threecard/RiskKnow.vue')
      },
      {
        path: '/prevention/dual_control/hid_fix_integral',
        name: 'hid_fix_integral',
        component: () => import('@/views/prevention/dualcontrol/HidFixIntegral.vue')
      },
      {
        path: '/prevention/dual_control/check_score',
        name: 'check_score',
        component: () => import('@/views/prevention/dualcontrol/CheckScore.vue')
      },
      {
        path: '/prevention/dual_control/integral_rewards',
        name: 'integral_rewards',
        component: () => import('@/views/prevention/dualcontrol/IntegralRewards.vue')
      },
      {
        path: '/prevention/dual_control/integral_dept_operation',
        name: 'integral_dept_operation',
        component: () => import('@/views/prevention/dualcontrol/IntegralDeptOperation.vue')
      },
      //人员定位
      {
        path: '/location/monitor',
        name: 'location_monitor',
        component: () => import('@/views/location/LocationMonitor.vue')
      },
      {
        path: '/location/monitor2',
        name: 'location_monitor2',
        component: () => import('@/views/location/LocationMonitor2.vue')
      },
      {
        path: '/location/ala2',
        name: 'location_ala',
        component: () => import('@/views/location/ala.vue')
      },
      {
        path: '/location/person2',
        name: 'location_person',
        component: () => import('@/views/location/person.vue')
      },
      {
        path: '/location/distribution2',
        name: 'location_distribution',
        component: () => import('@/views/location/distribution.vue')
      },
      {
        path: '/location/xzzx/cs',
        name: 'location_xzzx_cs',
        component: () => import('@/views/location/xzzx/cs.vue')
      },
      //外来人员登记
      {
        path: '/location/stuff_manage',
        name: 'location_stuff_manage',
        component: () => import('@/views/location/LocationStuffManage.vue')
      },
      {
        path: '/location/visitor_manage',
        name: 'location_visitor_manage',
        component: () => import('@/views/location/LocationVisitorManage.vue')
      },
      {
        path: '/location/stuff_manage3',
        name: 'location_stuff_manage3',
        component: () => import('@/views/location/LocationStuffManage3.vue')
      },
      {
        path: '/location/visitor_manage3',
        name: 'location_visitor_manage3',
        component: () => import('@/views/location/LocationVisitorManage3.vue')
      },
      {
        path: '/location/contractor_manage',
        name: 'location_contractor_manage',
        component: () => import('@/views/location/ContractorManage2.vue')
      },
      {
        path: '/location/person_register',
        name: 'person_register',
        component: () => import('@/views/location/PersonRegister.vue')
      },
      {
        path: '/location/vehicle_register',
        name: 'vehicle_register',
        component: () => import('@/views/location/VehicleRegister.vue')
      },
      {
        path: '/location/person_access_record',
        name: 'person_access_record',
        component: () => import('@/views/location/personAccessRecord.vue')
      },
      {
        path: '/location/vehicle_access_record',
        name: 'vehicle_access_record',
        component: () => import('@/views/location/VehicleAccessRecord.vue')
      },
      //定位卡管理
      {
        path: '/location/positioning_card',
        name: 'positioning_card',
        component: () => import('@/views/location/PositioningCard.vue')
      },
      {
        path: '/location/positioning_card2',
        name: 'positioning_card2',
        component: () => import('@/views/location/PositioningCard2.vue')
      },
      {
        path: '/location/positioning_card3',
        name: 'positioning_card3',
        component: () => import('@/views/location/PositioningCard3.vue')
      },
      {
        path: '/location/track_playback',
        name: 'track_playback',
        component: () => import('@/views/location/TrackPlayback.vue')
      },
      {
        path: '/location/track_playback2',
        name: 'track_playback2',
        component: () => import('@/views/location/TrackPlayback2.vue')
      },
      {
        path: '/location/track_playback3',
        name: 'track_playback3',
        component: () => import('@/views/location/TrackPlayback3.vue')
      },
      {
        path: '/location/second_door',
        name: 'second_door',
        component: () => import('@/views/location/SecondDoor.vue')
      },
      //报警管理
      {
        path: '/location/electric_fence_setting',
        name: 'electric_fence_setting',
        component: () => import('@/views/location/ElectronicFence.vue')
      },
      {
        path: '/location/electric_fence_setting2',
        name: 'electric_fence_setting2',
        component: () => import('@/views/location/ElectronicFence2.vue')
      },
      {
        path: '/location/electric_fence_setting3',
        name: 'electric_fence_setting3',
        component: () => import('@/views/location/ElectronicFence3.vue')
      },
      {
        path: '/location/alarm_summary',
        name: 'location_alarm_summary',
        component: () => import('@/views/location/AlarmSummary.vue')
      },
      {
        path: '/location/alarm_summary2',
        name: 'location_alarm_summary2',
        component: () => import('@/views/location/AlarmSummary2.vue')
      },
      {
        path: '/location/alarm_summary3',
        name: 'location_alarm_summary3',
        component: () => import('@/views/location/AlarmSummary3.vue')
      },
      {
        path: '/location/sos_alarm',
        name: 'sos_alarm',
        component: () => import('@/views/location/SosAlarm.vue')
      },
      {
        path: '/location/sos_alarm3',
        name: 'sos_alarm3',
        component: () => import('@/views/location/SosAlarm3.vue')
      },
      {
        path: '/location/location_system_station',
        name: 'location_system_station',
        component: () => import('@/views/location/LoStation.vue')
      },
      {
        path: '/location/location_system_station2',
        name: 'location_system_station2',
        component: () => import('@/views/location/LoStation2.vue')
      },
      {
        path: '/location/location_system_station3',
        name: 'location_system_station3',
        component: () => import('@/views/location/LoStation3.vue')
      },
      {
        path: '/location/location_system_beacon',
        name: 'location_system_beacon',
        component: () => import('@/views/location/LoBeacon.vue')
      },
      {
        path: '/location/location_system_beacon2',
        name: 'location_system_beacon2',
        component: () => import('@/views/location/LoBeacon2.vue')
      },
      {
        path: '/location/personnel_alarm_setting',
        name: 'personnel_alarm_setting',
        component: () => import('@/views/location/PersonnelAlarmSetting.vue')
      },
      {
        path: '/location/personnel_alarm_setting2',
        name: 'personnel_alarm_setting2',
        component: () => import('@/views/location/PersonnelAlarmSetting2.vue')
      },
      {
        path: '/location/personnel_alarm_setting3',
        name: 'personnel_alarm_setting3',
        component: () => import('@/views/location/PersonnelAlarmSetting3.vue')
      },
      {
        path: '/location/floor_manage2',
        name: 'floor_manage2',
        component: () => import('@/views/location/FloorManage2.vue')
      },
      {
        path: '/location/floor_manage3',
        name: 'floor_manage3',
        component: () => import('@/views/location/FloorManage3.vue')
      },
      {
        path: '/location/floor_manage',
        name: 'floor_manage',
        component: () => import('@/views/location/FloorManage.vue')
      },
      {
        path: '/location/statistic_manage',
        name: 'location_statistic_manage',
        component: () => import('@/views/location/StatisticManage.vue')
      },
      {
        path: '/location/vehicle_list',
        name: 'location_vehicle_list',
        component: () => import('@/views/location/VehicleList.vue')
      },
      {
        path: '/location/vehicle_visitor_record',
        name: 'location_vehicle_visitor_record',
        component: () => import('@/views/location/VehicleVisitorRecord.vue')
      },
      {
        path: '/location/vehicle_pass_record',
        name: 'location_vehicle_pass_record',
        component: () => import('@/views/location/VehiclePassRecord.vue')
      },
      //相关方管理
      {
        path: '/safe/relation/contractor',
        name: 'rel_contractor_management',
        component: () => import('@/views/safe/relation/RelContractor.vue')
      },
      {
        path: '/safe/relation/contractor_person',
        name: 'rel_contractor_person',
        component: () => import('@/views/safe/relation/RelContractorPerson.vue')
      },
      {
        path: '/safe/relation/contractor_statistics',
        name: 'rel_contractor_statistics',
        component: () => import('@/views/safe/relation/RelContractorStatistics.vue')
      },
      {
        path: '/safe/relation/supplier',
        name: 'rel_supplier',
        component: () => import('@/views/safe/relation/RelSupplier.vue')
      },
      //作业管理
      {
        path: '/safe/work/fire',
        name: 'work_fire',
        component: () => import('@/views/safe/work/WorkFire.vue')
      },
      {
        path: '/safe/work/temp_electric',
        name: 'work_temp_electric',
        component: () => import('@/views/safe/work/WorkTempElectric.vue')
      },
      {
        path: '/safe/work/confined_space',
        name: 'work_confined_space',
        component: () => import('@/views/safe/work/WorkConfinedSpace.vue')
      },
      {
        path: '/safe/work/high',
        name: 'work_high',
        component: () => import('@/views/safe/work/WorkHigh.vue')
      },
      {
        path: '/safe/work/hoisting',
        name: 'work_hoisting',
        component: () => import('@/views/safe/work/WorkHoisting.vue')
      },
      {
        path: '/safe/work/device_maintain',
        name: 'work_device_maintain',
        component: () => import('@/views/safe/work/WorkDeviceMaintain.vue')
      },
      {
        path: '/safe/work/blind_plate',
        name: 'work_blind_plate',
        component: () => import('@/views/safe/work/WorkBlindPlate.vue')
      },
      {
        path: '/safe/work/break_road',
        name: 'work_break_road',
        component: () => import('@/views/safe/work/WorkBreakRoad.vue')
      },
      {
        path: '/safe/work/land',
        name: 'work_land',
        component: () => import('@/views/safe/work/WorkLand.vue')
      },
      {
        path: '/safe/work/monitor',
        name: 'work_monitor',
        component: () => import('@/views/safe/work/WorkMonitor.vue')
      },
      {
        path: '/safe/work/monitor2',
        name: 'work_monitor2',
        component: () => import('@/views/safe/work/WorkMonitor2.vue')
      },
      //监控存储
      {
        path: '/safe/work/work_video_storage',
        name: 'work_video_storage',
        component: () => import('@/views/safe/work/WorkVideoStorage.vue')
      },
      {
        path: '/safe/work/database',
        name: 'work_database',
        component: () => import('@/views/safe/work/WorkDatabase.vue')
      },

      {
        path: '/safe/WorkDatabase/WorkbasicData',
        name: 'basicData',
        component: () => import('@/views/safe/WorkDatabase/WorkbasicData.vue')
      },
      {
        path: '/safe/WorkDatabase/WorkJSASecurityAnalysis',
        name: 'JSASecurityAnalysis',
        component: () => import('@/views/safe/WorkDatabase/WorkJSASecurityAnalysis.vue')
      },
      {
        path: '/safe/WorkDatabase/WorkSafetyMeasure',
        name: 'safetyMeasure',
        component: () => import('@/views/safe/WorkDatabase/WorkSafetyMeasure.vue')
      },
      {
        path: '/safe/WorkDatabase/WorkSecurityDisclosure',
        name: 'securityDisclosure',
        component: () => import('@/views/safe/WorkDatabase/WorkSecurityDisclosure.vue')
      },
      {
        path: '/safe/WorkDatabase/WorkCountersigningGroup',
        name: 'countersigningGroup',
        component: () => import('@/views/safe/WorkDatabase/WorkCountersigningGroup.vue')
      },
      {
        path: '/safe/WorkDatabase/WorkApprovalSetting',
        name: 'approvalSetting',
        component: () => import('@/views/safe/WorkDatabase/WorkApprovalSetting.vue')
      },
      {
        path: '/safe/WorkDatabase/WorkRelevantQualification',
        name: 'WorkRelevantQualification',
        component: () => import('@/views/safe/WorkDatabase/WorkRelevantQualification.vue')
      },
      {
        path: '/safe/work/statistic',
        name: 'work_statistic',
        component: () => import('@/views/safe/work/WorkStatistic.vue')
      },
      {
        path: '/safe/work/query',
        name: 'work_query',
        component: () => import('@/views/safe/work/WorkQuery.vue')
      },
      {
        path: '/safe/work/gas_analysis',
        name: 'gas_analysis',
        component: () => import('@/views/safe/work/WorkGasAnalysis.vue')
      },
      {
        path: '/safe/work/fence',
        name: 'work_fence',
        component: () => import('@/views/safe/work/WorkFence.vue')
      },
      {
        path: '/safe/work/alarm',
        name: 'work_alarm',
        component: () => import('@/views/safe/work/WorkAlarm.vue')
      },
      {
        path: '/safe/work/appoint',
        name: 'work_appoint',
        component: () => import('@/views/safe/work/WorkAppoint.vue')
      },
      {
        path: '/safe/work/safety_analysis',
        name: 'work_safety_analysis',
        component: () => import('@/views/safe/work/WorkSafetyAnalysis.vue')
      },
      //巡检
      {
        path: '/prevention/index',
        name: 'chinaisafe',
        component: () => import('@/views/prevention/index.vue')
      },
      {
        path: '/prevention/inspection/point',
        name: 'inspection_point',
        component: () => import('@/views/inspection/InspectionPoint.vue')
      },
      {
        path: '/prevention/inspection/plan',
        name: 'inspection_plan',
        component: () => import('@/views/inspection/InspectionPlan.vue')
      },
      {
        path: '/prevention/inspection/task',
        name: 'inspection_task',
        component: () => import('@/views/inspection/InspectionRecord.vue')
      },
      {
        path: '/prevention/inspection/result',
        name: 'inspection_result',
        component: () => import('@/views/inspection/InspectionResult.vue')
      },
      {
        path: '/prevention/inspection/statistics',
        name: 'inspection_statistics',
        component: () => import('@/views/inspection/InspectionStatistics.vue')
      },
      //变更管理
      {
        path: '/safe/change/change_apply',
        name: 'change_apply',
        component: () => import('@/views/safe/change/changeApply.vue')
      },
      {
        path: '/safe/change/change_accept',
        name: 'change_accept',
        component: () => import('@/views/safe/change/changeAccept.vue')
      },
      //设备设施
      {
        path: '/safe/change/project_three',
        name: 'project_three',
        component: () => import('@/views/safe/change/projectThree.vue')
      },
      {
        path: '/safe/device/device_ledger',
        name: 'device_ledger',
        component: () => import('@/views/safe/device/DeviceLedger.vue')
      },
      {
        path: '/safe/device/device_vital',
        name: 'device_vital',
        component: () => import('@/views/safe/device/DeviceVital.vue')
      },
      // 教育培训
      {
        path: "/safe/exam/question",
        name: 'question_manage',
        component: () => import('@/views/safe/education/exam/QuestionManage.vue'),
      },
      {
        path: '/safe/exam/paper',
        name: 'paper_manage',
        component: () => import('@/views/safe/education/exam/PaperManage.vue'),
      },
      {
        path: '/safe/train/course',
        name: 'course_manage',
        component: () => import('@/views/safe/education/train/CourseManage.vue'),
      },
      {
        path: '/safe/train/course_ware',
        name: 'course_ware_manage',
        component: () => import('@/views/safe/education/train/CourseWareManage.vue'),
      },
      {
        path: '/safe/train/train_plan',
        name: 'train_plan',
        component: () => import('@/views/safe/education/train/TrainPlan.vue'),
      },
      {
        path: '/safe/train/train_activity',
        name: 'train_activity',
        component: () => import('@/views/safe/education/train/TrainActivity.vue'),
      },
      {
        path: '/safe/online/exam',
        name: 'online_exam',
        component: () => import('@/views/safe/education/onlineexam/OnlineExam.vue'),
      },
      {
        path: '/safe/online/train',
        name: 'online_train',
        component: () => import('@/views/safe/education/onlinestudy/OnlineStudy.vue'),
      },
      {
        path: '/safe/outer/outer_docking',
        name: 'outer_docking',
        component: () => import('@/views/safe/education/outer/OuterDocking.vue'),
      },
      {
        path: '/safe/my_study/files',
        name: 'my_study',
        component: () => import('@/views/safe/education/myStudy/MyStudyFiles.vue'),
      },
      {
        path: '/safe/leader/leader_duty',
        name: 'leader_duty',
        component: () => import('@/views/safe/education/leader/LeaderDuty.vue'),
      },
      //法规与制度
      {
        path: '/safe/law_regulation',
        name: 'law_regulation',
        component: () => import('@/views/safe/regulation/LawRegulation.vue'),
      },
      {
        path: '/safe/file_management',
        name: 'file_management',
        component: () => import('@/views/safe/regulation/FileManagement.vue'),
      },
      {
        path: '/safe/safety/regulation',
        name: 'safety_regulation',
        component: () => import('@/views/safe/regulation/SafetyRegulation.vue'),
      },
      {
        path: '/safe/safety/operation',
        name: 'safety_operation',
        component: () => import('@/views/safe/regulation/SafetyOperation.vue'),
      },
      {
        path: '/safe/safety/document',
        name: 'safety_document',
        component: () => import('@/views/safe/regulation/SafetyDocument.vue'),
      },
      {
        path: '/safe/safety/commit',
        name: 'safety_commit',
        component: () => import('@/views/safe/goal/SafetyCommit.vue'),
      },
      {
        path: '/safe/safety/goal',
        name: 'safety_goal',
        component: () => import('@/views/safe/goal/SafetyGoal.vue'),
      },
      {
        path: '/safe/safety/manage',
        name: 'safety_manage',
        component: () => import('@/views/safe/goal/SafetyManage.vue'),
      },
      {
        path: '/safe/safety/produce_duty',
        name: 'safety_produce_duty',
        component: () => import('@/views/safe/goal/SafetyProduceDuty.vue'),
      },
      {
        path: '/safe/safety/performance',
        name: 'safety_performance',
        component: () => import('@/views/safe/goal/SafetyPerformance.vue'),
      },
      //应急管理
      {
        path: '/safe/emergency/team',
        name: 'emergency_team',
        component: () => import('@/views/safe/emergency/Team.vue'),
      },
      {
        path: '/safe/emergency/material',
        name: 'emergency_material',
        component: () => import('@/views/safe/emergency/Material.vue'),
      },
      {
        path: '/safe/emergency/plan',
        name: 'emergency_plan',
        component: () => import('@/views/safe/emergency/Plan.vue'),
      },
      {
        path: '/safe/emergency/drill',
        name: 'emergency_drill',
        component: () => import('@/views/safe/emergency/Drill.vue'),
      },
      //事故管理
      {
        path: '/safe/accident/injury',
        name: 'accident_injury',
        component: () => import('@/views/safe/accident/AccidentInjury.vue'),
      },
      {
        path: '/safe/accident/archive',
        name: 'accident_archive',
        component: () => import('@/views/safe/accident/AccidentArchive.vue'),
      },
      //职业卫生健康
      {
        path: '/safe/health/examination_items',
        name: 'health_examination_items',
        component: () => import('@/views/safe/health/HealthExamination.vue'),
      },
      {
        path: '/safe/health/examination_files',
        name: 'health_examination_files',
        component: () => import('@/views/safe/health/HealthExaminationFiles.vue'),
      },
      {
        path: '/safe/health/my_examination',
        name: 'my_health_examination',
        component: () => import('@/views/safe/health/MyExamination.vue'),
      },
      {
        path: '/safe/health/labor_protection',
        name: 'labor_protection',
        component: () => import('@/views/safe/health/LaborProtection.vue'),
      },
      {
        path: '/safe/health/labor_ware_house',
        name: 'labor_ware_house',
        component: () => import('@/views/safe/health/LaborWareHouse.vue'),
      },
      {
        path: '/safe/health/ware_house_records',
        name: 'ware_house_records',
        component: () => import('@/views/safe/health/WareHouseRecords.vue'),
      },
      //劳保领用记录
      {
        path: '/safe/health/labor_receive_records',
        name: 'labor_receive_records',
        component: () => import('@/views/safe/health/LaborReceiveRecords.vue'),
      },
      {
        path: '/safe/knowledge/knowledge_file',
        name: 'knowledge_file',
        component: () => import('@/views/safe/knowledge/knowledge.vue'),
      },
      //日志
      {
        path: '/system/user/login_log',
        name: 'login_log',
        component: () => import('@/views/system/log/LoginLog.vue'),
      },
      {
        path: '/system/user/business_audit_log',
        name: 'business_audit_log',
        component: () => import('@/views/system/log/BusinessAuditLog.vue'),
      },
      {
        path: '/system/user/user_manage_log',
        name: 'user_manage_log',
        component: () => import('@/views/system/log/UserManageLog.vue'),
      },
      {
        path: '/system/user/technological_process_log',
        name: 'technological_process_log',
        component: () => import('@/views/system/log/TechnologicalProcessLog.vue'),
      },
      // 其他设置
      {
        path: '/system/other/map_configuration',
        name: 'map_configuration',
        component: () => import('@/views/system/other/MapConfiguration.vue'),
      },
      {
        path: '/system/other/screen_configuration',
        name: 'screen_configuration',
        component: () => import('@/views/system/other/ScreenConfiguration.vue'),
      },
      {
        path: '/system/other/work_config',
        name: 'screen_configuration',
        component: () => import('@/views/system/config/WorkConfig.vue'),
      },

      // 用户管理
      {
        path: '/system/user/user_manage',
        name: 'user_manage',
        component: () => import('@/views/system/user/UserManage.vue'),
      },

      {
        path: '/system/user/role_manage',
        name: 'role_manage',
        component: () => import('@/views/system/user/RoleManage.vue'),
      },
      {
        path: '/system/user/post_manage',
        name: 'post_manage',
        component: () => import('@/views/system/user/PostManage.vue'),
      },
      {
        path: '/system/user/menu_manage',
        name: 'menu_manage',
        component: () => import('@/views/system/user/MenuManage.vue'),
      },
      {
        path: '/system/user/dept_manage',
        name: 'dept_manage',
        component: () => import('@/views/system/user/DeptManage.vue'),
      },
      {
        path: '/system/process/process_def',
        name: 'process_def',
        component: () => import('@/views/system/process/ProcessDef.vue')
      },
      {
        path: '/system/process/process_def_detail',
        name: 'process_def_detail',
        component: () => import('@/views/system/process/ProcessDefDetail.vue')
      },

      {
        path: '/system/perponFace/perponFaceAdd',
        name: 'perponFaceAdd',
        component: () => import('@/views/system/perponFace/perponFaceAdd.vue')
      },

      {
        path: '/system/perponFace/perponFaceLog',
        name: 'perponFaceLog',
        component: () => import('@/views/system/perponFace/perponFaceLog.vue')
      },
      {
        path: '/system/process/process_instance',
        name: 'process_instance',
        component: () => import('@/views/system/process/ProcessInstance.vue')
      },
      {
        path: '/notice/noticeList',
        name: 'noticeList',
        component: () => import('@/views/notice/NoticeList.vue')
      }
    ]
  },
  {
    path: "/screen/graph",
    name: 'screen_graph',
    component: () => import('@/views/screen/LargeScreenGraph.vue')
  },
  {
    path: "/screen/graph-demo",
    name: 'screen_graph_demo',
    component: () => import('@/views/screen/LargeScreenGraphDemo.vue')
  },
  {
    path: "/screen/now",
    name: 'screen_now',
    component: () => import('@/views/screen/LargeScreenNow.vue')
  },
  {
    path: "/screen/location",
    name: 'screen_location',
    component: () => import('@/views/screen/LargeScreenLocation.vue')
  },
  {
    path: "/screen/screens",
    name: 'screen_screens',
    component: () => import('@/views/screen/LargeScreens.vue')
  },
  {
    path: "/screen/prevent",
    name: 'screen_prevent',
    component: () => import('@/views/screen/LargeScreenPrevent.vue')
  },
  {
    path: "/screen/tickets",
    name: 'screen_tickets',
    component: () => import('@/views/screen/LargeScreenWorkTickets.vue')
  },
  {
    path: '/screen/hazard',
    name: 'screen_hazard',
    component: () => import('@/views/screen/LargeScreenHazardSource.vue')
  },
  {
    path: "/freeLoginPhone",
    name: 'free_login_phone',
    component: () => import('@/views/login/FreeLoginPhone.vue')
  },
  {
    path: "/autoLogin",
    name: 'auto_login',
    component: () => import('@/views/login/AutoLogin.vue')
  },
  {
    path: "/work/ticket_print",
    name: 'work_ticket_print',
    component: () => import('@/views/safe/work/WorkTicketPrint.vue')
  },
  {
    path: "/404", // 此处需特别注意置于最底部
    name: 'page_not_found',
    component: () => import('@/views/404')
  }
];


export default new Router({
  routes: constantRouterMap
});




// WEBPACK FOOTER //
// ./src/router/index.js